import { api } from '@/lib/api/client'
import type { Campaign, FlashDeal } from '@/modules/promo/model/types'

export const promoApi = {
  listCampaigns:  () => api.get<Campaign[]>('/promo/campaigns'),
  listFlashDeals: () => api.get<FlashDeal[]>('/promo/flash-deals'),
  adminListCampaigns:  () => api.get<Campaign[]>('/admin/promo/campaigns'),
  adminCreateCampaign: (p: Omit<Campaign, 'id'>) => api.post<Campaign>('/admin/promo/campaigns', p),
  adminUpdateCampaign: (id: string, p: Partial<Campaign>) => api.patch<Campaign>(`/admin/promo/campaigns/${id}`, p),
  adminDeleteCampaign: (id: string) => api.delete<void>(`/admin/promo/campaigns/${id}`),
  adminListFlashDeals:  () => api.get<FlashDeal[]>('/admin/promo/flash-deals'),
  adminCreateFlashDeal: (p: Omit<FlashDeal, 'id'>) => api.post<FlashDeal>('/admin/promo/flash-deals', p),
  adminUpdateFlashDeal: (id: string, p: Partial<FlashDeal>) => api.patch<FlashDeal>(`/admin/promo/flash-deals/${id}`, p),
  adminDeleteFlashDeal: (id: string) => api.delete<void>(`/admin/promo/flash-deals/${id}`),
}
